import React from 'react';
import Modal from 'react-bootstrap/Modal';

class Xoa extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      store: {},
    };
  }
  componentDidUpdate() {
    let { data, deletestore } = this.props;
    let { isShowDelModalStore } = deletestore;
    let { store } = this.state;
    if (data !== store && isShowDelModalStore) {
      this.setState({ store: data });
    }
  }
  deleteStore = () => () => {
    let { deleteStore, data } = this.props;
    deleteStore({ Id: data.StoreId });
  };
  render() {
    let props = this.props;
    let { deletestore, onHide } = props;
    let { isShowDelModalStore } = deletestore;
    return (
      <Modal
        show={isShowDelModalStore}
        size="modal-dialog modal-dialog"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <i className="mdi mdi-delete"></i>
            </span>
            Xác nhận xoá
          </h4>
          <button type="button" className="close-popup-new" onClick={onHide}>
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body className="">
          <form className="form tat-toan form-horizontal">
            <div className="form-body">
              <div className="form-body">
                <div className="form-group row">
                  <label
                    className="col-md-12 label-control text-left"
                    for="projectinput2"
                  >
                    Bạn có chắc chắn muốn xóa không?
                  </label>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-new-main btn-checknew"
            onClick={this.deleteStore()}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>
            Xác nhận
          </button>

          <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>
            Đóng
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default Xoa;
